<stx-checkbox-group [layoutDirection]="'2cols'" [formGroup]="formGroupReference" [options]="genderOptions"></stx-checkbox-group>
